import type { Translation } from '../../types';
import type { zns as en } from '../en/zns';

/** Zalo ZNS: mẫu tin, tin đã gửi, số không nhận tin. Lời thường. */
export const zns: Translation<typeof en> = {
  page: {
    title: 'Zalo ZNS',
    subtitle: 'Thông báo đến điện thoại khách hàng qua Official Account Zalo của nhà đăng ký: thông báo nào dùng mẫu Zalo nào, tin đã gửi, số không nhận tin.',
    crumb: 'E-mail & thông báo',
  },
  overview: {
    title: 'Tình trạng',
    off: 'Zalo ZNS đang tắt: không thông báo nào được gửi qua Zalo.',
    notConfigured: 'Chưa thiết lập Zalo ZNS (Cài đặt › Module › Thông báo › Zalo ZNS).',
    on: 'Đang bật (phiên bản cài đặt {{version}})',
    development: 'Đây là máy chủ thử nghiệm: tin chỉ đến quản trị viên của ứng dụng Zalo và của Official Account, không bao giờ đến khách hàng.',
    accessUntil: 'Mã truy cập dùng được đến',
    renewed: 'Gia hạn lần cuối',
    renewals: 'Số lần gia hạn',
    quota: 'Số tin còn được gửi hôm nay',
    quotaValue: 'còn {{remaining}} / {{daily}}',
    quotaAt: 'lúc {{at}}',
    lastProblem: 'Sự cố gần nhất',
    nextTry: 'Thử lại lúc',
    counts: '7 ngày qua',
    openConnection: 'Cài đặt kết nối',
    fallbackMinutes: 'E-mail chỉ gửi khi Zalo không gửi được sẽ chờ Zalo {{minutes}} phút.',
    chain: 'Mã truy cập',
    noChain: 'Chưa lấy: tin đầu tiên hoặc lần kiểm tra tiếp theo sẽ lấy.',
    previousChain: 'Vẫn là mã của phiên bản cài đặt trước (phiên bản mới thay khi được dùng lần đầu).',
    lastConnectionProblem: 'Sự cố gần nhất của kết nối',
  },
  state: {
    READY: 'Đang hoạt động',
    REFRESH_REFUSED: 'Zalo từ chối mã ủy quyền',
    REFRESH_UNKNOWN: 'Zalo chưa trả lời; đang thử lại',
  },
  health: {
    healthy: 'Hoạt động bình thường',
    degraded: 'Có sự cố',
    down: 'Không hoạt động',
    unknown: 'Chưa kiểm tra',
  },
  status: {
    PENDING: 'Đang chờ',
    SENDING: 'Đang gửi',
    SENT: 'Đã gửi',
    DELIVERED: 'Đã đến điện thoại',
    FAILED: 'Không gửi được',
    UNKNOWN: 'Chưa rõ',
    SUPPRESSED: 'Không gửi (số không nhận tin Zalo)',
  },
  purpose: { NOTIFICATION: 'Thông báo', TEST: 'Gửi thử' },
  emailMode: {
    ALSO: 'Gửi cả e-mail và Zalo',
    FALLBACK: 'Gửi Zalo trước, e-mail chỉ khi Zalo không gửi được',
  },
  emailModeHint: {
    ALSO: 'E-mail luôn được gửi; Zalo là kênh thêm.',
    FALLBACK: 'E-mail chờ kết quả Zalo và chỉ được gửi khi Zalo không gửi được tin.',
    onlyAlso: 'Đây là thông báo bắt buộc hoặc cần lưu bằng chứng: luôn gửi e-mail.',
  },
  source: {
    recipient_name: 'Tên người nhận',
    domain: 'Tên miền',
    domains: 'Các tên miền (ba tên đầu)',
    expires_on: 'Ngày hết hạn',
    days_left: 'Số ngày còn lại',
    years: 'Số năm',
    expired_on: 'Ngày đã hết hạn',
    renew_until: 'Gia hạn được đến',
    restore_until: 'Khôi phục được đến',
    amount: 'Số tiền',
    invoice_number: 'Số hoá đơn',
    brand_name: 'Tên thương hiệu',
    brand_phone: 'Đường dây hỗ trợ',
    brand_website: 'Trang web thương hiệu',
    today: 'Ngày gửi',
    text: 'Chữ cố định',
  },
  mappingError: {
    EVENT_NOT_ALLOWED: 'Thông báo này không bao giờ gửi qua Zalo',
    FALLBACK_NOT_ALLOWED: 'Thông báo này luôn phải gửi e-mail',
    TEMPLATE_ID_INVALID: 'Mã mẫu: chỉ gồm chữ và số',
    TOO_MANY_PARAMS: 'Tối đa 30 tham số',
    PARAM_NAME_INVALID: 'Tên tham số: chữ, số, dấu _ hoặc -',
    SOURCE_NOT_AVAILABLE: 'Thông báo này không có giá trị đó',
    SOURCE_UNKNOWN: 'Giá trị không rõ',
    FIXED_TEXT_LENGTH: 'Chữ cố định: từ 1 đến 200 ký tự',
    FIXED_TEXT_ONE_LINE: 'Chữ cố định: một dòng',
    FIXED_TEXT_IDENTIFIER: 'Chữ cố định không được chứa số giấy tờ, mã số thuế, số tài khoản hay địa chỉ e-mail',
    PARAM_VALUE_INVALID: 'Chọn một giá trị hoặc nhập chữ',
    PARAM_REQUIRED_BY_PROVIDER: 'Zalo yêu cầu tham số này',
    PARAM_NOT_IN_TEMPLATE: 'Mẫu Zalo không có tham số này',
  },
  zaloStatus: {
    ENABLE: 'Đã duyệt',
    PENDING_REVIEW: 'Đang chờ Zalo duyệt',
    REJECT: 'Zalo từ chối',
    DISABLE: 'Đã tắt',
    DELETE: 'Đã xoá',
  },
  zaloTag: {
    TRANSACTION: 'Giao dịch',
    IN_TRANSACTION: 'Giao dịch',
    CUSTOMER_CARE: 'Chăm sóc khách hàng',
    PROMOTION: 'Hậu mãi',
  },
  /** Codes of the notify branch, of its core and of the Zalo token chain. */
  code: {
    NOT_READY: 'Kết nối chưa sẵn sàng (chưa có mã truy cập): tin đang chờ',
    NOT_REACHED: 'Không kết nối được nhà cung cấp (đã thử lại)',
    NO_ANSWER: 'Nhà cung cấp không trả lời: tin có thể đã đến người nhận, hệ thống không tự gửi lại',
    INTERRUPTED: 'Việc gửi bị ngắt giữa chừng: tin có thể đã đến người nhận, hệ thống không tự gửi lại',
    OPTED_OUT: 'Số điện thoại này không nhận loại tin này',
    PARAMS_INCOMPLETE: 'Thông báo thiếu dữ liệu cho một tham số của mẫu',
    DELIVERY_FAILED: 'Nhà cung cấp báo sau đó rằng tin không đến được người nhận',
    RECIPIENT_INVALID: 'Số điện thoại không hợp lệ',
    RECIPIENT_UNREACHABLE: 'Số này không nhận được tin (không có tài khoản Zalo, không hoạt động hoặc từ chối loại tin này)',
    TEMPLATE_UNUSABLE: 'Không dùng được mẫu (chưa được duyệt, đã tắt hoặc không thuộc OA)',
    PARAMS_INVALID: 'Tham số không khớp với mẫu: cần sửa thiết lập mẫu',
    QUIET_HOURS: 'Không gửi vào ban đêm (22:00–06:00); tin sẽ gửi lúc 06:00',
    TRY_LATER: 'Nhà cung cấp chưa nhận được tin lúc này; hệ thống sẽ thử lại',
    SENDER_CONFIGURATION: 'Ứng dụng, Official Account hoặc quyền của chúng có vấn đề: mọi tin đều sẽ lỗi như vậy',
    SENDER_BALANCE: 'Tài khoản gửi tin không đủ số dư',
    TEST_MODE_LIMIT: 'Giới hạn của chế độ thử (chỉ quản trị viên nhận được tin)',
    REJECTED: 'Nhà cung cấp từ chối tin',
    NOT_FOUND: 'Không tìm thấy ở nhà cung cấp',
    ALREADY_EXISTS: 'Đã có ở nhà cung cấp',
    UNAUTHORIZED: 'Nhà cung cấp không chấp nhận mã truy cập; hệ thống thử lại với mã mới',
    IP_NOT_ALLOWED: 'Nhà cung cấp không nhận yêu cầu từ địa chỉ của máy chủ này',
    INVALID_REQUEST: 'Nhà cung cấp cho rằng yêu cầu không hợp lệ',
    CONFLICT: 'Nhà cung cấp báo có xung đột',
    QUOTA_EXCEEDED: 'Đã hết hạn mức gửi tin của nhà cung cấp',
    INSUFFICIENT_FUNDS: 'Tài khoản gửi tin không đủ số dư',
    RATE_LIMITED: 'Gửi quá nhiều yêu cầu đến nhà cung cấp; hệ thống sẽ thử lại',
    MAINTENANCE: 'Nhà cung cấp đang bảo trì',
    UNSUPPORTED: 'Nhà cung cấp không hỗ trợ việc này',
    REFRESHING: 'Một dịch vụ khác đang lấy mã truy cập',
    REFRESH_REFUSED: 'Zalo từ chối mã ủy quyền: hãy lấy Refresh Token mới từ Zalo và nhập trong cài đặt kết nối (Cài đặt › Module › Thông báo)',
    REFRESH_NO_ANSWER: 'Zalo không trả lời khi lấy mã truy cập; hệ thống thử lại',
    REFRESH_WAITING: 'Đang chờ để lấy lại mã truy cập',
    STATE_UNAVAILABLE: 'Không đọc, ghi được nơi giữ mã truy cập',
  },
  /** Zalo's own codes (modules/vendors/zalo-client/src/errors.rs). */
  zaloCode: {
    '-100': 'Zalo gặp lỗi không xác định, sẽ thử lại sau',
    '-101': 'Ứng dụng gửi tin không hợp lệ',
    '-102': 'Ứng dụng gửi tin không tồn tại',
    '-103': 'Ứng dụng chưa được kích hoạt',
    '-104': 'Khoá bí mật của ứng dụng không đúng',
    '-105': 'Ứng dụng chưa liên kết với Official Account',
    '-106': 'Zalo không hỗ trợ cách gọi này',
    '-107': 'Mã tin nhắn không hợp lệ',
    '-108': 'Số điện thoại không hợp lệ',
    '-109': 'Mã mẫu tin không hợp lệ',
    '-110': 'Người nhận dùng phiên bản Zalo quá cũ',
    '-111': 'Mẫu tin không có dữ liệu',
    '-112': 'Dữ liệu của mẫu tin không hợp lệ',
    '-1121': 'Một tham số dài quá giới hạn của mẫu',
    '-1122': 'Thiếu tham số của mẫu tin',
    '-1123': 'Zalo không tạo được mã QR',
    '-1124': 'Một tham số sai định dạng',
    '-113': 'Nút bấm của mẫu không hợp lệ',
    '-1131': 'Đường dẫn của nút bấm sai định dạng',
    '-1132': 'Mẫu phải có ít nhất một nút bấm',
    '-114': 'Người dùng không nhận được tin (tài khoản không hoạt động, tắt nhận tin hoặc phiên bản Zalo cũ)',
    '-115': 'Tài khoản Zalo Cloud không đủ số dư',
    '-116': 'Nội dung tham số không hợp lệ',
    '-117': 'OA hoặc ứng dụng chưa được cấp quyền dùng mẫu này',
    '-118': 'Tài khoản Zalo không tồn tại hoặc đã bị vô hiệu hoá',
    '-119': 'Tài khoản không thể nhận tin',
    '-120': 'OA chưa được cấp quyền dùng tính năng này (chưa mua gói dịch vụ)',
    '-1201': 'OA chưa có quyền tạo loại mẫu này',
    '-1202': 'OA không có quyền dùng hình ảnh, logo của mẫu',
    '-121': 'Mẫu tin không có nội dung',
    '-122': 'Yêu cầu gửi sai định dạng',
    '-123': 'Zalo không giải mã được tin',
    '-124': 'Mã truy cập không hợp lệ',
    '-1241': 'Ứng dụng Zalo đang bật kiểm tra appsecret_proof; hãy tắt tính năng này',
    '-125': 'ID Official Account không hợp lệ',
    '-126': 'Ví của chế độ thử không đủ số dư',
    '-127': 'Mẫu đang thử chỉ gửi được cho quản trị viên',
    '-128': 'Khoá mã hoá không tồn tại',
    '-129': 'Zalo không tạo được khoá mã hoá, sẽ thử lại sau',
    '-130': 'Nội dung vượt quá giới hạn ký tự',
    '-131': 'Mẫu tin chưa được Zalo duyệt',
    '-132': 'Tham số không hợp lệ',
    '-133': 'Mẫu này không được gửi ban đêm (22h–6h), sẽ gửi lúc 6h sáng',
    '-134': 'Người dùng chưa đồng ý nhận tin từ OA',
    '-135': 'OA chưa có quyền gửi tin qua số điện thoại (chưa xác thực hoặc đang dùng gói miễn phí)',
    '-1351': 'OA bị Zalo chặn gửi tin do vi phạm',
    '-136': 'Ứng dụng chưa liên kết với tài khoản Zalo Cloud',
    '-137': 'Thanh toán bằng tài khoản Zalo Cloud thất bại (ví không đủ số dư…)',
    '-138': 'Ứng dụng chưa có quyền dùng tính năng này',
    '-1381': 'OA chưa cho tiện ích dùng tài khoản Zalo Cloud',
    '-139': 'Người dùng từ chối nhận loại tin này',
    '-140': 'Người dùng không đủ điều kiện nhận loại tin này theo chính sách của Zalo',
    '-141': 'Người dùng từ chối nhận tin từ Official Account',
    '-142': 'Khoá RSA không tồn tại',
    '-143': 'Khoá RSA đã tồn tại',
    '-144': 'OA đã hết hạn mức gửi tin trong ngày',
    '-1441': 'OA đã hết hạn mức tin hậu mãi trong tháng',
    '-145': 'OA không được phép gửi loại nội dung này',
    '-146': 'Mẫu bị vô hiệu hoá do chất lượng gửi thấp',
    '-147': 'Mẫu đã hết hạn mức gửi trong ngày',
    '-1471': 'Đã hết hạn mức tin hậu mãi cho người dùng này trong tháng',
    '-1472': 'Đã hết hạn mức tin hậu mãi cho người dùng này trong ngày',
    '-148': 'Không tìm thấy mã hành trình',
    '-149': 'Mã hành trình không hợp lệ',
    '-1491': 'Loại mã hành trình không hợp với mẫu',
    '-150': 'Mã hành trình đã hết hạn',
    '-151': 'Không phải mẫu mã hoá đầu cuối',
    '-152': 'Zalo không lấy được khoá mã hoá đầu cuối, sẽ thử lại sau',
    '-153': 'Dữ liệu gửi sai quy định',
    '-158': 'Tệp tải lên quá dung lượng cho phép',
    '-159': 'Định dạng tệp tải lên không được phép',
    '-160': 'Đã hết hạn mức tạo, sửa mẫu hoặc tải tệp trong ngày',
    '-161': 'Chế độ gửi không hợp lệ',
    '-162': 'Chế độ gửi vượt hạn mức không dùng được cho loại tin này',
    '-249': 'Mẫu không hỗ trợ gửi theo người quan tâm',
    'HTTP': 'Zalo trả lời bằng một lỗi không có mã',
  },
  templates: {
    title: 'Mẫu tin',
    intro: 'Mỗi thông báo có thể gửi thêm đến Zalo của người nhận bằng một mẫu Zalo đã duyệt cho Official Account của nhà đăng ký. Thông báo có đường dẫn dùng một lần, có thông tin cá nhân hoặc gửi cho người ngoài không bao giờ gửi qua Zalo.',
    notice: 'Thông báo',
    template: 'Mẫu Zalo',
    mode: 'E-mail',
    none: 'Không gửi Zalo',
    on: 'Bật',
    off: 'Tắt',
    edit: 'Thiết lập',
    never: 'Không bao giờ gửi qua Zalo: {{list}}',
    dialogTitle: 'Mẫu Zalo cho “{{name}}”',
    dialogDescription: 'Mã mẫu của Zalo và giá trị cho từng tham số. Giá trị chỉ lấy từ thông báo; không bao giờ gửi giấy tờ tuỳ thân hay mã số thuế cá nhân.',
    enabled: 'Gửi thông báo này qua Zalo',
    templateId: 'Mã mẫu Zalo',
    templateIdHint: 'Như trong Zalo Cloud (ví dụ 295958).',
    load: 'Đọc mẫu từ Zalo',
    loaded: '{{name}} · {{status}} · {{tag}}{{price}}',
    price: ' · {{price}} đ mỗi tin',
    params: 'Tham số',
    paramName: 'Tham số (tên trong Zalo)',
    paramValue: 'Giá trị',
    required: 'bắt buộc',
    maxLength: 'tối đa {{n}} ký tự',
    addParam: 'Thêm tham số',
    remove: 'Bỏ',
    fixedText: 'Chữ',
    save: 'Lưu',
    saved: 'Đã lưu.',
    delete: 'Ngừng gửi qua Zalo',
    deleted: 'Thông báo này không còn gửi qua Zalo.',
    invalid: 'Một số tham số cần sửa.',
    notUsable: 'Zalo chưa cho gửi mẫu này (chưa được duyệt hoặc đã tắt).',
  },
  test: {
    title: 'Gửi thử',
    phone: 'Số điện thoại',
    phoneHint: 'Số di động Việt Nam. Trên máy chủ thử nghiệm chỉ quản trị viên của ứng dụng Zalo hoặc của OA nhận được.',
    send: 'Gửi thử',
    sample: 'Dùng dữ liệu mẫu của thông báo này.',
    result: 'Kết quả: {{status}}',
  },
  log: {
    title: 'Tin đã gửi',
    created: 'Tạo lúc',
    notice: 'Thông báo',
    phone: 'Số điện thoại',
    status: 'Trạng thái',
    email: 'E-mail',
    any: 'Tất cả',
    search: 'Tìm',
    empty: 'Chưa có tin nào.',
    older: 'Cũ hơn',
    first: 'Mới nhất',
    detailTitle: 'Tin Zalo',
    detailDescription: 'Nội dung đã gửi sang Zalo và Zalo trả lời gì.',
    template: 'Mẫu Zalo',
    params: 'Tham số đã gửi',
    tracking: 'Mã theo dõi',
    zaloId: 'Mã tin của Zalo',
    sent: 'Đã gửi lúc',
    delivered: 'Đến điện thoại lúc',
    attempts: 'Số lần thử',
    nextAttempt: 'Thử lại lúc',
    development: 'Chế độ thử (chỉ quản trị viên)',
    resend: 'Gửi lại',
    resendUnknownHint: 'Zalo không trả lời tin này: chỉ gửi lại khi khách chưa nhận được.',
    requeued: 'Đã đưa vào hàng chờ gửi lại.',
    by: 'Người gửi',
    emailStatus: 'E-mail của thông báo',
    zaloAnswer: 'Zalo trả lời',
  },
  optOuts: {
    title: 'Số không nhận tin Zalo',
    intro: 'Nhân viên thêm khi khách yêu cầu, hoặc hệ thống tự thêm khi Zalo báo người dùng từ chối tin của Official Account. Không ảnh hưởng đến e-mail.',
    phone: 'Số điện thoại',
    reason: 'Lý do',
    source: 'Người thêm',
    added: 'Thêm lúc',
    add: 'Thêm',
    already: 'Số này đã có trong danh sách.',
    withdraw: 'Bỏ khỏi danh sách',
    withdrawn: 'Đã bỏ khỏi danh sách.',
    empty: 'Chưa có số nào.',
    sourceName: { STAFF: 'Nhân viên', CHANNEL: 'Zalo (người dùng từ chối)' },
    everyChannel: 'mọi kênh',
  },
};
